// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareEarnestPaymentFields() {
    val props: Array<SerializableProperty<EarnestPayment, *>> = arrayOf(EarnestPayment__id, EarnestPayment_user, EarnestPayment_at, EarnestPayment_method, EarnestPayment_priceInCents)
    EarnestPayment.serializer().properties { props }
}
val <K> DataClassPath<K, EarnestPayment>._id: DataClassPath<K, UUID> get() = this[EarnestPayment__id]
val <K> DataClassPath<K, EarnestPayment>.user: DataClassPath<K, UUID> get() = this[EarnestPayment_user]
val <K> DataClassPath<K, EarnestPayment>.at: DataClassPath<K, Instant> get() = this[EarnestPayment_at]
val <K> DataClassPath<K, EarnestPayment>.method: DataClassPath<K, String> get() = this[EarnestPayment_method]
val <K> DataClassPath<K, EarnestPayment>.priceInCents: DataClassPath<K, Int> get() = this[EarnestPayment_priceInCents]
inline val EarnestPayment.Companion.path: DataClassPath<EarnestPayment, EarnestPayment> get() = path<EarnestPayment>()


object EarnestPayment__id: SerializableProperty<EarnestPayment, UUID> {
    override val name: String by lazy { EarnestPayment.serializer().descriptor.getElementName(0) }
    override fun get(receiver: EarnestPayment): UUID = receiver._id
    override fun setCopy(receiver: EarnestPayment, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (EarnestPayment.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { EarnestPayment.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = uuid()
    override val defaultCode: String? = "uuid()" 
}
object EarnestPayment_user: SerializableProperty<EarnestPayment, UUID> {
    override val name: String by lazy { EarnestPayment.serializer().descriptor.getElementName(1) }
    override fun get(receiver: EarnestPayment): UUID = receiver.user
    override fun setCopy(receiver: EarnestPayment, value: UUID) = receiver.copy(user = value)
    override val serializer: KSerializer<UUID> by lazy { (EarnestPayment.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { EarnestPayment.serializer().descriptor.getElementAnnotations(1) }
}
object EarnestPayment_at: SerializableProperty<EarnestPayment, Instant> {
    override val name: String by lazy { EarnestPayment.serializer().descriptor.getElementName(2) }
    override fun get(receiver: EarnestPayment): Instant = receiver.at
    override fun setCopy(receiver: EarnestPayment, value: Instant) = receiver.copy(at = value)
    override val serializer: KSerializer<Instant> by lazy { (EarnestPayment.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<Instant> }
    override val annotations: List<Annotation> by lazy { EarnestPayment.serializer().descriptor.getElementAnnotations(2) }
    override val default: Instant = now()
    override val defaultCode: String? = "now()" 
}
object EarnestPayment_method: SerializableProperty<EarnestPayment, String> {
    override val name: String by lazy { EarnestPayment.serializer().descriptor.getElementName(3) }
    override fun get(receiver: EarnestPayment): String = receiver.method
    override fun setCopy(receiver: EarnestPayment, value: String) = receiver.copy(method = value)
    override val serializer: KSerializer<String> by lazy { (EarnestPayment.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { EarnestPayment.serializer().descriptor.getElementAnnotations(3) }
    override val default: String = "Not recorded"
    override val defaultCode: String? = "\"Not recorded\"" 
}
object EarnestPayment_priceInCents: SerializableProperty<EarnestPayment, Int> {
    override val name: String by lazy { EarnestPayment.serializer().descriptor.getElementName(4) }
    override fun get(receiver: EarnestPayment): Int = receiver.priceInCents
    override fun setCopy(receiver: EarnestPayment, value: Int) = receiver.copy(priceInCents = value)
    override val serializer: KSerializer<Int> by lazy { (EarnestPayment.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<Int> }
    override val annotations: List<Annotation> by lazy { EarnestPayment.serializer().descriptor.getElementAnnotations(4) }
    override val default: Int = 0
    override val defaultCode: String? = "0" 
}
